export default "__VITE_ASSET__sxGO2h9F__"